import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgNoNetwork(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M69.135 71.836a2 2 0 0 1-2 2h-.322a2 2 0 0 1-2-2v-7.083a2 2 0 0 1 2-2h.322a2 2 0 0 1 2 2v7.083Z"
        fill="#78B441"
      />
      <path
        d="M62.278 77.385a2 2 0 0 1 2-2h5.24a2 2 0 0 1 2 2v11.18a2 2 0 0 1-2 2h-5.24a2 2 0 0 1-2-2v-11.18Z"
        fill="#00664F"
      />
      <path d="M60.898 74.205a2 2 0 0 1 2-2h8a2 2 0 0 1 0 4h-8a2 2 0 0 1-2-2Z" fill="#007A5F" />
      <path
        d="M58.593 81.536a.9.9 0 0 1 .885-.733h14.565a.9.9 0 0 1 .884.728l2.634 13.533a.9.9 0 0 1-.884 1.072H56.934a.9.9 0 0 1-.884-1.066l2.543-13.534Z"
        fill="#599F40"
      />
      <path d="M58.731 80.803h6.06l2.984 15.333H55.85l2.881-15.333Z" fill="#78B441" />
      <path
        d="M53.875 94.595a.9.9 0 0 1 .9-.9h24.6a.9.9 0 0 1 .9.9v4.7h-26.4v-4.7Z"
        fill="#599F40"
      />
      <path
        d="M53.377 95.695a2 2 0 0 1 2-2h12.721a2 2 0 0 1 1.954 1.574l.877 4.026H53.376v-3.6Z"
        fill="#78B441"
      />
      <path
        d="m64.791 80.003.141.011c.32.058.58.307.645.636l2.382 12.245h.05l.253.011a2.913 2.913 0 0 1 2.591 2.281v.001l.001.001v.004l.004.016.014.062.05.233.176.808.49 2.247a.8.8 0 0 1-1.563.34c-.163-.748-.348-1.591-.49-2.247l-.176-.808c-.022-.099-.04-.178-.05-.232l-.015-.062-.002-.016-.002-.004v-.002a1.313 1.313 0 0 0-1.283-1.033H67.3a.8.8 0 0 1-.785-.647l-2.383-12.246h-5.4a.8.8 0 1 1 0-1.6h6.06Z"
        fill="#00664F"
      />
      <path
        d="M25.861 64.284c5.204 5.204 12.925 9.12 21.643 9.12 16.732 0 30.296-13.564 30.296-30.296 0-8.385-3.406-15.974-8.91-21.46L25.861 64.285Z"
        fill="#78B441"
      />
      <path
        d="M68.67 21.735c5.503 5.485 8.91 13.073 8.91 21.458 0 12.957-8.135 24.011-19.576 28.341 7.16-5.54 11.77-14.216 11.77-23.97 0-7.559-2.768-14.47-7.346-19.778l6.241-6.051Z"
        fill="#599F40"
      />
      <path
        d="M68.454 21.105c3.418 3.418-3.422 15.8-15.277 27.654C41.32 60.615 28.94 67.454 25.522 64.036c-3.418-3.418 3.422-15.8 15.277-27.655 11.855-11.855 24.236-18.695 27.655-15.276Z"
        fill="#CAE8DF"
      />
      <path
        d="M56.18 24.03c5.601-3.333 10.079-4.491 11.93-2.64 1.907 1.907.618 6.605-2.953 12.446 1.996-4.555 2.308-8.21.48-10.038-1.75-1.75-5.173-1.54-9.456.231Z"
        fill="#A6DBCB"
      />
      <path
        d="M38.761 30.983a3.189 3.189 0 0 1 .983 3.137l15.328 12.86a107.116 107.116 0 0 1-2.885 2.916l-14.429-13.54a3.189 3.189 0 1 1 1.003-5.373Z"
        fill="#0F172A"
      />
      <path
        d="M34.259 31.25a3.19 3.19 0 0 1 5.485 2.87l15.328 12.86c-.6.63-1.214 1.26-1.842 1.888l-1.042 1.028-14.43-13.54a3.189 3.189 0 0 1-3.5-5.105Zm17.9 16.425c.19-.191.38-.383.568-.575l-11.14-9.345 10.571 9.92ZM37.698 32.18a1.589 1.589 0 1 0-.498 2.677l.108-.036a1.6 1.6 0 0 1 1.018.04 1.6 1.6 0 0 1-.138-1.117 1.588 1.588 0 0 0-.49-1.564ZM84.936 98.598a.8.8 0 0 1 0 1.599H25.5a.8.8 0 1 1 0-1.6h59.436Zm9.564 0a.8.8 0 1 1 0 1.599h-5.11a.8.8 0 1 1 0-1.6h5.11Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgNoNetwork)
